import styled from '@emotion/styled'
import { AiOutlineInfoCircle, AiOutlineLeft } from 'react-icons/ai'
import TitleHeader from '../../../components/app-layout/AppHeader/TitleHeader'
import Text from '../../../components/common/Text'
import BaseButton from '../../../components/common/Button'
import { mobile, useScreen } from '../../../utils/responsive-helper'
import * as paths from '../../../constant/path'
import SearchCouponForm from '../SearchCouponForm'
import { CheckCouponValues, CouponDetail } from '../../../services/coupon/coupon-typed'
import { useGetCouponCollected } from '../../../services/coupon/coupon-query'
import { BACKGROUND, DARK_GRAY, ORANGE, WHITE } from '../../../constant/colors'
import dayjs from 'dayjs'
import Modal from '../../../components/common/Modal'
import { useVisibility } from '../../../utils/custom-hook'
import { useState } from 'react'
import { useHistory } from 'react-router'
import CouponInformation from '../../../components/CouponInformation'

const Layout = styled.div`
  padding: 8px 0;
  ${mobile} {
    margin-top: 64px;
  }
`

const SliderLayout = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 16px;
  margin-top: 16px;

  ${mobile} {
    grid-template-columns: 100%;
  }
`

const SliderStyle = styled.div`
  display: flex;
  width: calc(100% - 16px);
  height: 120px;
  margin-right: 10px;
  background: linear-gradient(270deg, #ffb292 0%, ${ORANGE} 100%);
  border-radius: 4px;

  ${mobile} {
    width: 100%;
    height: 102px;
  }
`

const DotLeftStyle = styled.div`
  position: relative;
  top: 52px;
  left: -6px;
  width: 16px;
  height: 16px;
  background: ${BACKGROUND};
  border-radius: 50%;
  display: inline-flex;

  ${mobile} {
    top: 43px;
    left: -6px;
  }
`

const DotRightStyle = styled.div`
  position: relative;
  top: 52px;
  left: calc(100% - 22px);
  width: 16px;
  height: 16px;
  background: ${BACKGROUND};
  border-radius: 50%;
  display: inline-flex;

  ${mobile} {
    top: 43px;
  }
`

const ContentStyle = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding-right: 16px;
  flex-direction: column;
  justify-content: center;
`

const HeaderStyle = styled.div`
  display: flex;
  justify-content: space-between;
`

const HeaderTextStyle = styled(Text)`
  font-size: 20px;
  margin-bottom: 4px;
  padding-right: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;

  ${mobile} {
    font-size: 16px;
  }
`

const BodyStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
`

const DetailStyle = styled.div``

const DetailTextStyle = styled(Text)`
  font-size: 16px;

  ${mobile} {
    font-size: 12px;
  }
`

const ButtonStyle = styled(BaseButton)`
  width: 52px;
  height: 24px;
  line-height: 24px;
  border: none;
  border-radius: 36px;
  margin-left: 4px;
  padding: 0px;
`

const ShopCartCoupons = () => {
  const history = useHistory()
  const { isMobile } = useScreen()
  const [modalVisiblelity, modal] = useVisibility()
  const { data: couponList } = useGetCouponCollected()
  const [couponDetail, setCouponDetail] = useState<CouponDetail>()

  const handleMoreInformation = (coupon: CouponDetail) => {
    setCouponDetail(coupon)
    isMobile
      ? history.push(
          paths.couponDetail({
            routeParam: {
              couponId: coupon.id,
            },
            queryParam: {
              page: paths.shopCartCoupons(),
            },
          }),
        )
      : modal.show()
  }

  return (
    <Layout id="shop-cart-coupons">
      {isMobile && (
        <TitleHeader title={`เลือกคูปองส่วนลด`} icon={<AiOutlineLeft />} path={paths.shopCart()} />
      )}
      <SearchCouponForm
        onSubmit={(form: CheckCouponValues) => {
          console.log(form.coupon)
        }}
      />
      <SliderLayout>
        {couponList?.map((coupon, index) => (
          <SliderStyle key={index}>
            <DotLeftStyle />
            <DotRightStyle />
            <ContentStyle>
              <HeaderStyle>
                <HeaderTextStyle color={WHITE} type="Bold">
                  {coupon.title}
                </HeaderTextStyle>
                <Text
                  color={WHITE}
                  style={{ paddingTop: 4 }}
                  onClick={() => handleMoreInformation(coupon)}
                >
                  <AiOutlineInfoCircle />
                </Text>
              </HeaderStyle>
              <BodyStyle>
                <DetailStyle>
                  <DetailTextStyle
                    color={WHITE}
                  >{`Min. spend ฿${coupon.minSpend}`}</DetailTextStyle>
                  <DetailTextStyle color={WHITE}>
                    {`Valid until ${dayjs(coupon.endDate).format('DD/MM/YYYY')}`}
                  </DetailTextStyle>
                </DetailStyle>
                <ButtonStyle
                  background={WHITE}
                  fontSize={12}
                  fontColor={DARK_GRAY}
                  onClick={() => console.log('button1')}
                >
                  ใช้เลย
                </ButtonStyle>
              </BodyStyle>
            </ContentStyle>
          </SliderStyle>
        ))}
      </SliderLayout>
      <Modal
        visible={modalVisiblelity}
        headerComponent={
          <Text type="SemiBold" size={24}>
            เงื่อนไขการใช้คูปอง
          </Text>
        }
        closeIconSize={24}
        onOk={() => {
          modal.hide()
        }}
        onCancel={modal.hide}
        hideFooter
        style={{ width: 480, height: '620px' }}
      >
        <CouponInformation
          couponDetail={couponDetail}
          buttonText="ใช้เลย"
          onClickButton={() => console.log('button2')}
        />
      </Modal>
    </Layout>
  )
}

export default ShopCartCoupons
